
/* 
URLs para comunicarnos con las diferentes apis
*/

export const API_URI = "https://ilusiona-api-prod.azurewebsites.net/api";
//export const API_URI = "https://localhost:5001/api";
//export const URLIDENTITY = "http://localhost:5003";
export const URLIDENTITY = "https://ilusiona-identityserver-prod.azurewebsites.net";
export const LOCAL = false;


